import { useNavigate } from 'react-router-dom'
import { MonitorCheck, Globe } from 'lucide-react'
import type { AuthState } from '@/hooks/useAuth'
import { useProxyConfig } from '@/hooks/useProxyConfig'
import { MemberSearch } from '@/components/shared/MemberSearch'
import type { User } from '@/api/users'

interface TopbarProps {
  auth: AuthState
  can: (permission: string) => boolean
}

export function Topbar({ auth: _auth, can: _can }: TopbarProps) {
  const navigate = useNavigate()
  const { isElectron, appVersion } = useProxyConfig()

  function handleMemberSelect(user: User) {
    navigate(`/members/${user.id}`)
  }

  return (
    <header
      className="h-12 flex items-center px-4 gap-3 shrink-0 border-b border-white/8 backdrop-blur-sm"
      style={{ background: 'linear-gradient(90deg, #0a1624 0%, #0c1d14 50%, #0a1624 100%)' }}
    >
      <div className="flex-1 relative max-w-lg">
        <MemberSearch
          onSelect={handleMemberSelect}
          placeholder="Buscar miembro por nombre o cédula..."
          inputClassName="w-full bg-white/5 border border-white/10 rounded-xl pl-10 pr-4 py-2 text-sm text-white/80 placeholder:text-white/25 focus:outline-none focus:ring-1 focus:ring-white/20 focus:border-white/20 transition-all disabled:opacity-50"
        />
        <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[9px] text-white/20 bg-white/5 border border-white/8 px-1.5 py-0.5 rounded font-mono pointer-events-none">
          Ctrl+K
        </span>
      </div>

      <div className="flex items-center gap-2 shrink-0">
        {isElectron ? (
          <span className="flex items-center gap-1.5 text-[11px] font-medium text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 px-2.5 py-1 rounded-full">
            <MonitorCheck className="w-3 h-3 shrink-0" />
            App local{appVersion ? ` v${appVersion}` : ''}
          </span>
        ) : (
          <span className="flex items-center gap-1.5 text-[11px] font-medium text-white/35 bg-white/5 border border-white/10 px-2.5 py-1 rounded-full">
            <Globe className="w-3 h-3 shrink-0" />
            Web
          </span>
        )}
      </div>
    </header>
  )
}
